import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlConfig } from '@shared/config/url.config';
import { Maintenance } from '@features/maintenance/maintenance';

@Injectable({providedIn: "root"})
export class MaintenanceService {
    
    private readonly maintenanceEndpoint = `${UrlConfig.urlAdmin}maintenances`;

    constructor(private http: HttpClient) { }

    getMaintenance(): Observable<Maintenance> {
        return this.http.get<Maintenance>(this.maintenanceEndpoint);
    }
}
